import { createReducer, on } from '@ngrx/store';
import { RemindersAnalyticsActions } from './reminders-analytics.actions';
import { RemindersAnalyticsState, initialRemindersAnalyticsState } from './models/reminders-analytics-state.models';

export const remindersAnalyticsReducer = createReducer(
  initialRemindersAnalyticsState,

  on(RemindersAnalyticsActions.loadOverview, (state): RemindersAnalyticsState => ({
    ...state,
    loading: true,
    error: null
  })),
  on(RemindersAnalyticsActions.loadOverviewSuccess, (state, { overview }): RemindersAnalyticsState => ({
    ...state,
    overview,
    loading: false,
    error: null
  })),
  on(RemindersAnalyticsActions.loadOverviewFailure, (state, { error }): RemindersAnalyticsState => ({
    ...state,
    loading: false,
    error
  })),

  on(RemindersAnalyticsActions.loadTrend, (state): RemindersAnalyticsState => ({
    ...state,
    loading: true,
    error: null
  })),
  on(RemindersAnalyticsActions.loadTrendSuccess, (state, { trend }): RemindersAnalyticsState => ({
    ...state,
    trend,
    loading: false,
    error: null
  })),
  on(RemindersAnalyticsActions.loadTrendFailure, (state, { error }): RemindersAnalyticsState => ({
    ...state,
    loading: false,
    error
  })),

  on(RemindersAnalyticsActions.loadTracker, (state): RemindersAnalyticsState => ({
    ...state,
    loading: true,
    error: null
  })),
  on(RemindersAnalyticsActions.loadTrackerSuccess, (state, { tracker }): RemindersAnalyticsState => ({
    ...state,
    tracker,
    loading: false,
    error: null
  })),
  on(RemindersAnalyticsActions.loadTrackerFailure, (state, { error }): RemindersAnalyticsState => ({
    ...state,
    loading: false,
    error
  })),

  on(RemindersAnalyticsActions.clearRemindersAnalyticsState, (): RemindersAnalyticsState => ({
    ...initialRemindersAnalyticsState
  }))
);
